(function ($, window, document) {
  if (!window.theme) {
    return;
  }

  var measureRaf = null;
  var lastCompressed = null;
  var handlersBound = false;

  function getAvailableWidth($nav) {
    var $wrapper = $('#header--nav--wrapper');
    if (!$wrapper.length) {
      $wrapper = $nav.parent();
    }
    return $wrapper.innerWidth();
  }

  function getContentWidth($nav) {
    var $clone = $nav.clone();
    $clone
      .removeAttr('id')
      .removeClass('site-nav--compress site-nav--init')
      .addClass('site-nav--measure')
      .css({
        position: 'absolute',
        visibility: 'hidden',
        height: 'auto',
        width: 'auto',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        left: '-9999px',
        top: '-9999px'
      });

    $('body').append($clone);
    var width = $clone[0].scrollWidth;
    $clone.remove();
    return width;
  }

  function applyState($nav, shouldCompress) {
    if (lastCompressed === shouldCompress) {
      $nav.addClass('site-nav--init');
      return;
    }

    lastCompressed = shouldCompress;
    $nav.toggleClass('site-nav--compress', shouldCompress);
    $('.site-header').toggleClass('site-nav--compress', shouldCompress);
    $nav.addClass('site-nav--init');
  }

  function controlNav() {
    if (!theme.cache || !theme.cache.$siteNav || !theme.cache.$siteNav.length) {
      return;
    }

    var $nav = theme.cache.$siteNav;
    var availableWidth = getAvailableWidth($nav);
    if (!availableWidth) {
      return;
    }

    var contentWidth = getContentWidth($nav);
    if (!contentWidth) {
      return;
    }

    var buffer = 8;
    var shouldCompress = contentWidth > (availableWidth - buffer);
    applyState($nav, shouldCompress);
  }

  function scheduleMeasure() {
    if (measureRaf) {
      window.cancelAnimationFrame(measureRaf);
    }
    measureRaf = window.requestAnimationFrame(controlNav);
  }

  function bindHandlers() {
    if (handlersBound) {
      return;
    }
    handlersBound = true;

    var debounce = theme.debounce || function (fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    };

    var onResize = debounce(scheduleMeasure, 150);
    $(window).on('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('pageshow', scheduleMeasure);
    window.addEventListener('load', scheduleMeasure);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleMeasure);
    }
  }

  theme.fitNav = function () {
    bindHandlers();
    scheduleMeasure();
  };
})(jQuery, window, document);
